import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getRSAServiceList(context, payload) {
    return axios
      .get("/api/rsa_service_types/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getRSAServiceListOnly(context, type) {
    if (type == undefined) {
      return axios
        .get(`/api/rsa_service_types/dropdown_list`)
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/rsa_service_types/dropdown_list?delivery_type=${type}`)
        .then((res) => res.data);
    }
  },
  addRSAService(context, payload) {
    return axios
      .post("/api/rsa_service_types", payload)
      .then((res) => res.data);
  },
  addCarrierService(context, payload) {
    return axios
      .post("/api/carrier_service_type/add", payload)
      .then((res) => res.data);
  },
  getService(context, id) {
    return axios
      .get(`/api/rsa_service_type/edit/${id}`)

      .then((res) => res.data);
  },

  updateService(context, payload) {
    return axios
      .patch(`/api/rsa_service_type/update/${payload.id}`, payload)
      .then((res) => res.data);
  },
  updateCarrierService(context, payload) {
    return axios
      .patch(`/api/carrier_service_type/update/${payload.id}`, payload)
      .then((res) => res.data);
  },
  getCarrierServiceList(context, payload) {
    return axios
      .get("/api/carrier_service_type/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getCarrierService(context, id) {
    return axios
      .get(`/api/carrier_service_type/edit/${id}`)

      .then((res) => res.data);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
